import { FormikProps, useFormik } from 'formik';
import { getAddExerciseLoadFormulaFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { IExerciseLoadFormula } from '../../../../types/interfaces/exercise-load-formula';
import { FormikValues } from 'formik/dist/types';
import { usePostPutExerciseLoadFormula } from '../../../../services/redux/api/appConfigApi';

export function useAddExerciseLoadFormulaComponent(
  onClose: () => void,
  exerciseLoadFormula?: IExerciseLoadFormula,
) {
  const { t } = useTranslation();
  const [postPutExerciseLoadFormula, { isLoading }] =
    usePostPutExerciseLoadFormula();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddExerciseLoadFormulaFormValidation(t),
    initialValues: {
      nameKey: exerciseLoadFormula?.nameKey || '',
      value: exerciseLoadFormula?.value || '',
      priority: exerciseLoadFormula?.priority || '',
      active: exerciseLoadFormula?.active ?? true,
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutExerciseLoadFormula({
      id: exerciseLoadFormula?.id,
      body: {
        nameKey: values.nameKey,
        value: values.value,
        priority: values.priority,
        active: values.active,
      },
    })
      .unwrap()
      .then(() => {
        onClose();
      })
      .catch((error: any) => {
        if (error?.status === 400) {
          const originalErrorMessage = (
            error?.message ||
            error?.data?.message ||
            ''
          ).trim();
          const errorMessageLower = originalErrorMessage.toLowerCase();

          if (
            errorMessageLower.includes('namekey') ||
            errorMessageLower.includes('name key')
          ) {
            formik.setFieldTouched('nameKey', true, false);
            formik.setFieldError('nameKey', originalErrorMessage);
          } else if (
            errorMessageLower.includes('value') ||
            errorMessageLower.includes('formula')
          ) {
            formik.setFieldTouched('value', true, false);
            formik.setFieldError('value', originalErrorMessage);
          }
        }
      });
  }

  return { formik, isLoading };
}
